//디바이스 체크
export const IS_MOBILE = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
export const IS_ANDROID = /Android/i.test(navigator.userAgent);
export const IS_IPHONE = /iPhone|iPad|iPod/i.test(navigator.userAgent);
export const IS_APPLE_DEVICE = /iPhone|iPad|iPod|Macintosh/i.test(navigator.userAgent);
export const IS_CHROME = /Chrome/i.test(navigator.userAgent);

export const ROOT_PATH_PREFIX = window.rootPathPrefix ?? '';
